import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

// Models
import { DictKeyEntry, DictKeyEntryResponse } from '@core/models/app/dict-key.model';

/**
 * API d'édition inline des entrées du dictionnaire de traduction.
 * Endpoints : GET dict/entry?field=xx / POST dict/save
 */
@Injectable({ providedIn: 'root' })
export class DictKeyApi {
	constructor(private http: HttpClient) {}

	getEntry(field: string): Observable<DictKeyEntryResponse> {
		return this.http.get<DictKeyEntryResponse>('dict/entry', {
			params: { field },
		});
	}

	saveEntry(entry: DictKeyEntry): Observable<unknown> {
		return this.http.post('dict/save', entry);
	}
}
